<template>
  <div class="footer-wrapper">
    <div class="bottom">
      <div class="bottom_top">
        <div class="bottom_top_left">
          <h3>友情链接</h3>
          <ul>
            <li>
              <a href="https://www.nju.edu.cn/" target="_blank">南京大学</a>
            </li>
            <!-- <li>
              <a href="http://skbigdata.nju.edu.cn" target="_blank">南京大学双创数据中心
              </a>
            </li>
            <li>
              <a href="http://www.ds.pku.edu.cn/" target="_blank">北京大学大数据科学研究中心
              </a>
            </li>
            <li>
              <a href="http://www.ids.tsinghua.edu.cn/" target="_blank">清华大学数据科学研究院
              </a>
            </li> -->
          </ul>
        </div>
        <div class="bottom_top_right">

        </div>
      </div>
      <div class="bottom_bottom">
        Copyright 2019 - 2025 © 南京大学智能软件工程实验室
        <a href="http://beian.miit.gov.cn/" target="_blank">苏ICP备14002894号-12</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mFooter"
};
</script>

<style scoped>
.footer-wrapper {
  height: auto;
  width: 100%;
  background-color: #1d1d1d;
  text-align: center;
  color: #ffffff;
}

.bottom {
  width: 1200px;
  margin: 0 auto;
  height: 150px;
  padding: 50px 0;
}

.bottom_top {
  height: 130px;
}

.bottom_top_left {
  width: 800px;
  float: left;
}

.bottom_top_left h3 {
  margin-bottom: 10px;
  text-align: left;
}

.bottom_top_left ul {
  padding: 0;
  margin: 0;
}

.bottom_top_left ul li {
  float: left;
  text-align: left;
  width: 50%;
  line-height: 26px;
}

.bottom_top_left ul li a {
  color: white;
  text-decoration: none;
}

.bottom_top_left ul li a:hover {
  color: #63065f;
}

li {
  list-style: none;
}

.bottom_top_right {
  width: 310px;
  height: 52px;
  float: right;
  margin-top: 20px;
  /* background: url("../assets/logo/logo_light.png"); */
}

.bottom_bottom {
  clear: both;
  height: 20px;
  line-height: 20px;
}
</style>
